import HelTag from "react-helmet";
import { useParams } from "react-router-dom";
import { TabInterface } from "../../Interfaces/TabInterface";
import { PageHeader, TabGroup } from "../../share/Components";
import BackupRecord from "./Items/BackupRecord";

const Downloads = () => {
  const params = useParams();
  const listTab: Array<TabInterface> = [
    {
      title: "پرونده",
      icon: "rayteb-file",
      className: {
        iconClass: "text-3xl ",
        className: "px-10 pb-1",
        titleClass: "text-xs",
      },
      index: true,
      element: <BackupRecord />,
    },
  ];
  return (
    <>
      <HelTag>
        <title>بیماران</title>
      </HelTag>
      <PageHeader title="دانلود ها" />
      <TabGroup items={listTab} />
    </>
  );
};

export default Downloads;
